import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import config from '../../config/apiConfig';

const PlanContext = createContext();

export const usePlan = () => useContext(PlanContext);

export const PlanProvider = ({ children }) => {
    const [ajustes, setAjustes] = useState({
        plan: 'RESTAURANTE',
        usaPedidos: false,
        usaKds: false,
        usaWeb: false,
        usaMenuQr: false,
        cantidadPos: 0,
        cantidadTpv: 0,
        cargado: false,
    });

    const cargarPlan = useCallback(async () => {
        const token = localStorage.getItem('token');
        if (!token) return;

        try {
            const response = await fetch(config.api_url + '/api/configuracion/valores', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'token': token }
            });
            const data = await response.json();

            if (data.completado && data.ajustes) {
                setAjustes({
                    plan: data.ajustes.plan || 'RESTAURANTE',
                    usaPedidos: Number(data.ajustes.usa_pedidos || 0) === 1,
                    usaKds: Number(data.ajustes.usa_kds || 0) === 1,
                    usaWeb: Number(data.ajustes.usa_web || 0) === 1,
                    usaMenuQr: Number(data.ajustes.usa_menu_qr || 0) === 1,
                    cantidadPos: Number(data.ajustes.cantidad_pos || 0),
                    cantidadTpv: Number(data.ajustes.cantidad_tpv || 0),
                    cargado: true,
                });
            }
        } catch (e) {
            console.error("Error cargando plan del negocio:", e);
        }
    }, []);

    useEffect(() => {
        cargarPlan();
    }, [cargarPlan]);

    // tienePOS: acceso a funciones POS (venta rapida/caja, comandas)
    // tienePedidosWeb: acceso a pedidos online (tienda QR, despacho, plataformas)
    // tieneMesas: gestion de mesas, exclusiva del Plan Restaurante
    const tienePOS = ajustes.plan === 'POS' || ajustes.plan === 'RESTAURANTE';
    const tienePedidosWeb = ajustes.plan === 'MENU_QR' || ajustes.plan === 'RESTAURANTE';
    const tieneMesas = ajustes.plan === 'RESTAURANTE';

    return (
        <PlanContext.Provider value={{ ...ajustes, tienePOS, tienePedidosWeb, tieneMesas, cargarPlan }}>
            {children}
        </PlanContext.Provider>
    );
};
